import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { addOrEditItems } from "../../instantAnswers/orders-addOrEditItems";
import { cancelOrder } from "../../instantAnswers/orders-cancelOrder";
import { editOrderInformation } from "../../instantAnswers/orders-editOrderInformation";
import { insiderFreeShipping } from "../../instantAnswers/orders-insiderFreeShipping";
import { internationalOrderSettings } from "../../instantAnswers/orders-internationalOrderSettings";
import { questionAboutCustomer } from "../../instantAnswers/orders-questionAboutCustomer";
import { RequestCommissionChanges } from "../../instantAnswers/orders-requestCommissionChanges";
import { splitOrder } from "../../instantAnswers/orders-splitOrder";
import { orderNewStateVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderNewBrandNodes = function useOrderNewBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    QuestionAboutCustomerNewState: {
      id: "QuestionAboutCustomerNewState",
      label: strictLocalize({
        id: "aaKOkv",
        defaultMessage: [{
          "type": 0,
          "value": "Find customer information"
        }]
      }),
      level: 2,
      isNodeVisible: orderNewStateVisibilityFn,
      instantAnswer: questionAboutCustomer(strictLocalize)
    },
    AddOrEditItemsNewState: {
      id: "AddOrEditItemsNewState",
      label: strictLocalize({
        id: "XOqOmK",
        defaultMessage: [{
          "type": 0,
          "value": "Add or edit items in order"
        }]
      }),
      level: 2,
      isNodeVisible: orderNewStateVisibilityFn,
      instantAnswer: addOrEditItems(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER]
    },
    EditOrderInformationNewState: {
      id: "EditOrderInformationNewState",
      label: strictLocalize({
        id: "Au/+F5",
        defaultMessage: [{
          "type": 0,
          "value": "Edit order information"
        }]
      }),
      level: 2,
      isNodeVisible: orderNewStateVisibilityFn,
      instantAnswer: editOrderInformation(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER]
    },
    InternationalOrderSettingsNewState: {
      id: "InternationalOrderSettingsNewState",
      label: strictLocalize({
        id: "4jq1KK",
        defaultMessage: [{
          "type": 0,
          "value": "International order settings"
        }]
      }),
      level: 2,
      isNodeVisible: orderNewStateVisibilityFn,
      instantAnswer: internationalOrderSettings(strictLocalize),
      articles: [articles.International.LOCATION_SHOP_LIVE]
    },
    RequestCommissionChangesNewState: {
      id: "RequestCommissionChangesNewState",
      label: strictLocalize({
        id: "/jYVoe",
        defaultMessage: [{
          "type": 0,
          "value": "Request commission change"
        }]
      }),
      level: 2,
      isNodeVisible: orderNewStateVisibilityFn,
      instantAnswer: RequestCommissionChanges(strictLocalize),
      articles: [articles.FaireDirect.ZERO_COMMISSION]
    },
    InsiderFreeShippingNewState: {
      id: "InsiderFreeShippingNewState",
      label: strictLocalize({
        id: "+LqDHr",
        defaultMessage: [{
          "type": 0,
          "value": "Insider free shipping"
        }]
      }),
      level: 2,
      instantAnswer: insiderFreeShipping(strictLocalize),
      articles: [articles.INSIDER.INSIDER_BRAND_PARTNERSHIP],
      isNodeVisible: orderNewStateVisibilityFn
    },
    SplitOrderNewState: {
      id: "SplitOrderNewState",
      label: strictLocalize({
        id: "wxYTQH",
        defaultMessage: [{
          "type": 0,
          "value": "Split order"
        }]
      }),
      level: 2,
      instantAnswer: splitOrder(strictLocalize),
      articles: [articles.FulfillingOrders.SPLIT_ATS_ORDER, articles.FulfillingOrders.SPLIT_PREORDER],
      isNodeVisible: orderNewStateVisibilityFn
    },
    CancelOrderNewState: {
      id: "CancelOrderNewState",
      label: strictLocalize({
        id: "CJTXVi",
        defaultMessage: [{
          "type": 0,
          "value": "Cancel order"
        }]
      }),
      level: 2,
      isNodeVisible: orderNewStateVisibilityFn,
      instantAnswer: cancelOrder(strictLocalize),
      articles: [articles.FulfillingOrders.FULFILLING_ORDER]
    }
  };
};